import React from "react";
import { FaMedal, FaShieldAlt, FaGlobe, FaLock, FaHandshake } from "react-icons/fa";

function Features() {
  return (
    <div className="features-section">
      <div className="feature-box">
        <FaMedal className="feature-icon" />
        <h4>ORIGINAL PRODUCT</h4>
        <p>100% Original product that covered warranty by the vendor.</p>
      </div>

      <div className="feature-box">
        <FaShieldAlt className="feature-icon" />
        <h4>CLINICALLY TESTED</h4>
        <p>All products are clinically tested and certified for safety and efficacy.</p>
      </div>

      <div className="feature-box">
        <FaHandshake className="feature-icon" />
        <h4>TRUSTED PARTNER</h4>
        <p>Your reliable health partner with thousands of satisfied customers.</p>
      </div>

      <div className="feature-box">
        <FaLock className="feature-icon" />
        <h4>100% SECURE</h4>
        <p>Your payments are secure with our private security network.</p>
      </div>
    </div>
  );
}

export default Features;
